import { apiCall, apiCallAdmin } from "../../services/api-service";

export const getfielsApi = async (value) => {
  const response = await apiCall("get", `register_page${value}`);
  return response?.data;
};

export const registerSubmitApi = async (data) => {
  return apiCall("post", "field_config", data);
};

export const getGateListApi = async (term) => {
  return apiCall("get", "gate/autosuggestion", null, {
    params: { term },
  });
};

export const getLocationListApi = async (term) => {
  return apiCallAdmin("get", "get_location", null, {
    params: { term },
  });
};
export const getDeptListApi = async (term) => {
  return apiCallAdmin("get", "get_department", null, {
    params: { term },
  });
};

export const getFieldListApi = async (term) => {
  return apiCall("get", "get_fields");
};

export const getOptionsListApi = async (term) => {
  return apiCall("get", `register_page/get_fields/${term}`);
};

//Edit
export const getEditApi = async (id) => {
  const response = await apiCall("get", `field_config/${id}`);
  return response?.data;
};

//Update
export const UpdateFieldsApi = async (data, id) => {
  return apiCall("put", `field_config/${id}`, data);
};
